import { Routes } from "@angular/router";
import { LayoutComponent } from "./layout/layout.component";
import { AlterarSenhaExpiradaComponent } from "./modules/autenticacao/alterar-senha-expirada/alterar-senha-expirada.component";
import { LoginComponent } from "./modules/autenticacao/login/login.component";
import { EsqueciSenhaComponent } from "./modules/autenticacao/esqueci-senha/esqueci-senha.component";
import { ListaCadastroRegistroComponent } from "./modules/lista-integracao-cadastro/lista-cadastro-registro/lista-cadastro-registro.component";
import { routes } from "./modules/routing";

export const AppRoutes: Routes = [
  { path: "", redirectTo: "/app/home", pathMatch: "full" },
  { path: "login", component: LoginComponent },
  { path: "recuperarsenha", component: EsqueciSenhaComponent },
  { path: "alterarsenhaexpirada", component: AlterarSenhaExpiradaComponent },
  { path: "listaformcadastro", component: ListaCadastroRegistroComponent },
  { 
    path: "app", 
    component: LayoutComponent,
    children: routes
  }
];
